export default __webpack_public_path__ + "static/media/art-pro-red-poster-3.b6f5c2f1.jpg";